import { InjectionToken } from '@angular/core';
import { CurrencyService } from 'ib-web-commons/app/core/utils/ib-commons-currency-service';
import { upgradeAJSServiceProvider } from 'ib-web-commons/utils'; 
export const AJSGiftCardsCurrencyService = new InjectionToken('CurrencyService');
export const AJSGiftCardsCurrencyServiceProvider = upgradeAJSServiceProvider('CurrencyService', AJSGiftCardsCurrencyService);
export interface GiftCardsCurrencyServiceType extends CurrencyService {
    formatPrice(currencyData, price, decimals, roundedByService?, space?)
    getCurrencyObject(serviceCurrency)
}
